import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  coachDemoImg,
  CalendarIconGray,
  ClockIconGray,
  ForwardArrow,
  BackwardArrow,
} from "../../constant/imagePath";
import classes from "./PerformanceEvaluationCard.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { Button } from "../Button/Button";
import { LinkButtonWithIcon } from "../LinkButtonWithIcon/LinkButtonWithIcon";

import LinkBtnClasses from "../LinkButtonWithIcon/LinkButtonWithIcon.module.css";
import { ReactSVG } from "react-svg";

export const PerformanceEvaluationCard = ({ date, time, text, userData, onClick }) => {
  const [showMore, setShowMore] = useState(false);
  return (
    <>
      <style jsx>{`
        .${LinkBtnClasses.btnWithIcon}:hover {
          color: ${Colors.neutralShadesOfNero} !important;
        }
        .${LinkBtnClasses.btnWithIcon}:hover img {
          filter: unset !important;
        }
      `}</style>
      <div
        className={`${[classes.card].join(" ")}`}
        style={{ border: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
        onClick={onClick}
      >
        {/* Card Header */}
        <div className={`${[classes.header].join(" ")}`}>
          {/* Image */}
          <img
            src={userData?.photo}
            className={`${[classes.cardImg].join(" ")}`}
          />
          {/* Name and Date and Time */}
          <div className={`${[classes.nameAndTime].join(" ")}`}>
            <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
              {userData?.displayName}
            </h5>
            <ul>
              <li style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
                <ReactSVG src={CalendarIconGray} />
                <span style={{ ...Fonts.p2 }}>{date}</span>
              </li>
              <li style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
                <ReactSVG src={ClockIconGray} />

                <span style={{ ...Fonts.p2 }}>{time}</span>
              </li>
            </ul>
          </div>
        </div>
        {/* Card Content */}
        <div className={`${[classes.content].join(" ")}`}>
          <p
            className={`${[
              classes.description,
              showMore && classes.unlimitedLines,
            ].join(" ")}`}
            style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
          >
            {text}
          </p>
        </div>
        {/* Show More */}
        <LinkButtonWithIcon
          text={showMore ? "Show Less" : "Show more"}
          leftIcon={showMore ? BackwardArrow : ForwardArrow}
          primary={false}
          onClick={(e) => {
            e.stopPropagation()
            setShowMore(!showMore);
          }}
        />
      </div>
    </>
  );
};

PerformanceEvaluationCard.propType = {
  time: PropTypes.string,
  date: PropTypes.string,
  text: PropTypes.string,
  userData: PropTypes.object,
};

PerformanceEvaluationCard.defaultProps = {
  time: "Aug 37, 2021",
  date: "12:30PM- 2:30PM",
  text: "John has a knack. He can teach through his writings. He inspires confidence in his students, and by reading. Watch the Ball, you'll be inspired too",
  userData: {
    displayName: "Mackenize McDonald",
    photo: coachDemoImg,
  },
};
